<template>
    <v-app id="inspire">
        <Header type="search" />
        <v-main class="grey lighten-3">
            <v-container>
                <v-row>
                    <Menu />
                    <v-container class="col-10">
                        <v-row>
                            <v-col class="page-top d-flex justify-space-between" cols="12">
                                <div>
                                    <div class="page-title">Отчеты отдела продаж</div>
                                    <div class="breadcrumb">Отчеты отдела продаж</div>
                                </div>
                            </v-col>
                        </v-row>
                        <Grid :column="1" :gap="20">
                            <Block :padding="20" :withBorder="true" :overflowHidden="true">
                                <div class="filter">
                                    <Grid :column="4" :gap="20">
                                        <div class="filter__field">
                                            <span class="label">Период создания заявки</span>
                                            <VueDatePicker no-title no-header range v-model="date1" format="DD.MM.YYYY">
                                                <template #activator="{ date }">
                                                    <button class="custom__date-button" ref="activator" type="button">
                                                        <span class="full-width">
                                                            {{ date || 'Выбрать' }}
                                                        </span>
                                                        <v-icon dark small class="mr-2">
                                                            mdi-calendar-blank-outline
                                                        </v-icon>
                                                    </button>
                                                </template>
                                            </VueDatePicker>
                                        </div>
                                        <div class="filter__field">
                                            <span class="label">Период продажи членства</span>
                                            <VueDatePicker no-title no-header range v-model="date2" format="DD.MM.YYYY">
                                                <template #activator="{ date }">
                                                    <button class="custom__date-button" ref="activator" type="button">
                                                        <span class="full-width">
                                                            {{ date || 'Выбрать' }}
                                                        </span>
                                                        <v-icon dark small class="mr-2">
                                                            mdi-calendar-blank-outline
                                                        </v-icon>
                                                    </button>
                                                </template>
                                            </VueDatePicker>
                                        </div>
                                        <div class="filter__field">
                                            <span class="label">Период продажи пакета</span>
                                            <VueDatePicker no-title no-header range v-model="date3" format="DD.MM.YYYY">
                                                <template #activator="{ date }">
                                                    <button class="custom__date-button" ref="activator" type="button">
                                                        <span class="full-width">
                                                            {{ date || 'Выбрать' }}
                                                        </span>
                                                        <v-icon dark small class="mr-2">
                                                            mdi-calendar-blank-outline
                                                        </v-icon>
                                                    </button>
                                                </template>
                                            </VueDatePicker>
                                        </div>
                                    </Grid>
                                    <div class="filter__button-block">
                                        <v-btn dark class="filter-button">
                                            Сформировать
                                        </v-btn>
                                    </div>
                                </div>
                            </Block>
                            <Block :padding="20" :withBorder="true" :overflowHidden="true">
                                <div class="report-content">
                                    <div class="report-content__controll">
                                        <v-btn>
                                            <Icon iconName="save" width="16" height="16" viewBox="0 0 14 14"
                                                strockeWidth="1" />
                                            Скачать
                                        </v-btn>
                                        <v-btn>
                                            <Icon iconName="printer" width="16" height="16" viewBox="0 0 16 16"
                                                strockeWidth="1" />
                                            Печать
                                        </v-btn>
                                    </div>
                                </div>
                            </Block>
                        </Grid>
                    </v-container>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
import { globalMethods } from "@/mixins/globalMethods";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import { VueDatePicker } from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
export default {
    name: 'ReportsTm2',
    mixins: [globalMethods],
    components: {
        Header,
        Menu,
        VueDatePicker
    },
    data() {
        return {
            date1: null,
            date2: null,
            date3: null,
            select: null,
            showFilterGrid: false,
            rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        }
    }
}
</script>
<style scoped lang="scss">
.page-top {
    margin-bottom: 20px;
}

.filter {
    &__field {
        .label {
            color: #1A1A1A;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            display: block;
            margin-bottom: 8px;
        }

        .custom__date-button {
            background: #fff !important;
            color: #767676 !important;
            border: 1px solid #E0E0E0 !important;
            border-radius: 12px !important;
            width: 100%;
            min-width: 100%;
            box-sizing: border-box;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            i {
                color: #767676 !important;
                margin: 0 !important;
                font-size: 20px !important;

            }

        }
    }

    &__button-block {
        padding-top: 20px;

        button {
            margin-left: 0;
        }
    }
}

.report-content {
    min-height: 392px;

    &__controll {
        display: flex;
        align-items: center;

        button {
            background: #F1F1F1;
            border-radius: 12px;
            box-shadow: none;
            text-transform: none;
            color: #1A1A1A;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;

            &:not(:last-child) {
                margin-right: 10px;
            }

            svg {
                margin-right: 10px;
            }
        }
    }
}
</style>